import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/', icon: 'ri-home-4-line' },
  { name: '最新上线', path: '/category/zuixin', icon: 'ri-flashlight-line' },
  { name: '热门推荐', path: '/category/remen', icon: 'ri-fire-line' },
  { name: '电影', path: '/category/dianying', icon: 'ri-film-line' },
  { name: '电视剧', path: '/category/dianshiju', icon: 'ri-tv-line' },
  { name: '综艺', path: '/category/zongyi', icon: 'ri-emotion-laugh-line' },
  { name: '动漫', path: '/category/dongman', icon: 'ri-rocket-line' },
];

const sourceLinks = [
  { name: '红桃视频', path: '/category/hongtao' },
  { name: '樱桃视频', path: '/category/yingtao' },
  { name: '茄子视频', path: '/category/qiezi' },
  { name: '糖心视频', path: '/category/tangxin' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sourceOpen, setSourceOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSourceOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-background-50 border-b border-transparent'
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-play-circle-fill text-background-50 text-xl"></i>
          </div>
          <span className="text-xl font-heading font-bold text-foreground-900 whitespace-nowrap">
            密桃视频
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              <i className={`${link.icon} mr-1.5`}></i>
              {link.name}
            </Link>
          ))}

          <div className="relative ml-1">
            <button
              onClick={() => setSourceOpen(!sourceOpen)}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap flex items-center gap-1 ${
                sourceOpen
                  ? 'bg-accent-100 text-accent-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              <i className="ri-links-line mr-1"></i>
              源站
              <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${sourceOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {sourceOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setSourceOpen(false)}></div>
                <div className="absolute top-full mt-1 right-0 w-40 bg-background-50 rounded-lg border border-background-200/80 py-1.5 z-50">
                  {sourceLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="block px-4 py-2.5 text-sm text-foreground-600 hover:text-primary-600 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              </>
            )}
          </div>

          <Link
            to="/about"
            className={`ml-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'bg-secondary-100 text-secondary-700'
                : 'text-foreground-500 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            <i className="ri-information-line mr-1"></i>
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} mr-2`}></i>
                {link.name}
              </Link>
            ))}
            <div className="border-t border-background-200/70 my-1 pt-1">
              <p className="px-3 py-1 text-xs text-foreground-400 font-medium uppercase tracking-wider">源站聚合</p>
              {sourceLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="px-3 py-2.5 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors block"
                >
                  <i className="ri-links-line mr-2"></i>
                  {link.name}
                </Link>
              ))}
            </div>
            <div className="border-t border-background-200/70 mt-1 pt-1">
              <Link
                to="/about"
                className="px-3 py-2.5 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors block"
              >
                <i className="ri-information-line mr-2"></i>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}